export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_PUSH_NOTIFICATIONS = 'mpn';
export const HYDRA_SEARCH_INLINE_VERTICAL_RECOS = 'pita'; // [P]ain [I]n [T]he [A]ss || Search page inline vertical right side recos
export const HYDRA_HF_LOCALE = 'hola'; // Zappos HF locale test
export const HYDRA_OOSM = 'oosm'; // [O]ut [O]f [S]tock [M]obile
export const HYDRA_CHECKOUT_SHIP_SECTION_ADJUSTMENT = 'cssa'; // [C]heckout [S]hip [S]ection [A]djustment
export const HYDRA_CHECKOUT_REWARDS_REDEMPTION = 'crr'; // [C]heckout [R]ewards [R]edemption
export const HYDRA_CHECKOUT_MOVE_TO_FAVORITES = 'cmtf'; // [C]heckout [M]ove [T]o [F]avorites
export const HYDRA_DYNAMIC_REWARDS_BNR = 'drbn'; // [D]ynamic [R]ewards [B]a[N]ner
export const HYDRA_DYNAMIC_NONLOGGEDIN_BNR = 'dbnl'; // [D]ynamic [B]anner for [N]on-[L]ogged in users.
export const HYDRA_BRAND_NAME_SEARCH = 'bnsr'; // [B]rand [N]ame [S]ea[R]ch
export const HYDRA_SEARCH_COLOR_SWATCHES = 'crss'; // Search [C]olo[r] [S]watche[s]
export const HYDRA_PLACEBO_SEARCH = 'posh'; // [P]laceb[o] [S]earc[h]
export const HYDRA_PLACEBO_PDP = 'popp'; // [P]laceb[o] [P]roduct [P]age
export const HYDRA_PDP_PRODUCT_ANGLES = 'pdng'; // [PD]P Product a[NG]les
export const HYDRA_6PM_MARTY_RETURNS = '6mrt'; // [6]pm [M]arty [R]e[t]urns
export const HYDRA_NEW_VIP = 'nvip'; // [N]ew [VIP]
export const HYDRA_ORDER_DETAIL_FIT_SURVEY = 'orfs'; // [Or]der Detail [F]it [S]urvey
export const HYDRA_STREAM_RESPONSE = 'strm'; // Response [Str]ea[m]ing
export const HYDRA_VIP_PRIME = 'vprime'; // [V]ip [PRIME]
export const HYDRA_SOCIAL_COLLECTIONS = 'soc'; // [So]cial [C]ollections
export const HYDRA_BEST_EXPERIENCE = 'bexp'; // Response [B]est [Exp]erience
export const HYDRA_CHECKOUT_SHIPPING_DOWNGRADE = 'csd'; // [C]heckout [S]hipping [D]owngrade
export const HYDRA_FONT_PRELOAD = 'fp'; // [F]ont [P]reload
export const HYDRA_LAS = 'las'; // [L]ogin [As]sistant
export const HYDRA_SIZE_RECOMMENDER_TOOLTIP = 'srtt'; // [S]ize [R]ecommender [T]ool[t]ip
export const HYDRA_ADS = 'ads';
export const HYDRA_RET = 'ret'; // [Re]wards [T]ransparency
export const HYDRA_ZEN_RETURNS = 'fzr'; // [F]ind[Z]en [R]eturns
export const HYDRA_BUY_NOW_BUTTON = 'bn'; // [B]uy [N]ow Button
export const HYDRA_LAST_SELECTED_SIZE = 'lass'; // [La]st [S]elected [S]ize
export const HYDRA_SEO_H1_TITLE_COPY = 'shtc'; // [S]EO [H]1 [T]itle [C]opy
export const HYDRA_SEO_COPY_LOCATION = 'scop'; // [S]EO [Co]py [P]osition
export const HYDRA_BANNER_ADS_SEARCH = 'bads'; // [B]anner [ADS]
export const HYDRA_UNRECOGNIZED_HEADER = 'ugh'; // [U]nrecognized [G]lobal [H]eader
export const HYDRA_SAVE_ODSP = 'sop'; // [S]ave [O]ds[P]
